export default "__VITE_ASSET__4IHqwK5l__"